import { configure } from 'instantsearch.js/es/widgets';

const configuration = configure({
    attributesToSnippet: ['body:60'],
    snippetEllipsisText: '…',
    removeWordsIfNoResults: 'allOptional',
});

export default configuration;